import { render, staticRenderFns } from "./ExamProfiles.vue?vue&type=template&id=124cbdc3"
import script from "./ExamProfiles.vue?vue&type=script&lang=js"
export * from "./ExamProfiles.vue?vue&type=script&lang=js"
import style0 from "./ExamProfiles.vue?vue&type=style&index=0&id=124cbdc3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports